import axios, { AxiosError } from "axios";
import useSWR from "swr";
import { useContext } from "react";
import { pollingInterval } from "../../../constants/pollingInterval";
import { AuthContext } from "../../../context/AuthContext";
import { BybitEndpointEnum } from "../../../enums/endpoints";
import { DataContext } from "../../../context/DataContext";
import { BYBIT_API_URL } from "../../../utils/env";
import { bybitAddresses } from "../../../constants/admin";
import { IBybitPosition } from "../../../interfaces/bybit";

export const useBybitPositions = (overrideAccount?: string) => {
  const { tokenId } = useContext(AuthContext);
  const { address } = useContext(DataContext);
  const account = overrideAccount || address;

  const swr = useSWR<IBybitPosition[], AxiosError>(
    // If tokenId & account are not available, the request will not fetch
    tokenId && account && bybitAddresses.includes(account) ?
      [
        BYBIT_API_URL(BybitEndpointEnum.ACCOUNT_POSITIONS),
        tokenId,
        account,
      ] :
      undefined,
    async () => {
      try {
        const accountSummary = await axios.get<any>(
          BYBIT_API_URL(BybitEndpointEnum.ACCOUNT_POSITIONS),
          {
            withCredentials: true,
            headers: {
              Authorization: `Bearer ${tokenId}`,
              "Access-Control-Allow-Origin": "*",
            },
            params: {
              account,
            },
          }
        );

        return accountSummary.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    {
      refreshInterval: pollingInterval[BybitEndpointEnum.ACCOUNT_POSITIONS],
    }
  );

  return {
    ...swr,
  };
};
